import { createIntlCache, createIntl, PrimitiveType } from "react-intl";
import { DEFAULT_LANGUAGE, LANG_RESOURCES } from "./interfaces";
import { SupportedLanguages } from "../common/controls/lang-switcher";
import { MergeTranslateKeys, USER_LANG_KEY } from "./keys";

export function getUserLocalization(): SupportedLanguages {
  const stored = localStorage.getItem(USER_LANG_KEY) as SupportedLanguages | null;

    if (stored === "ru" || stored === "en") return stored;

  const browser = navigator.language.split("-")[0];
  return browser === "ru" ? "ru" : "en";

  // if (userLang === null) {
  //   const navigateLang = getNavigatorLang();
  //   updateUserLang(navigateLang);
  //   return navigateLang as SupportedLanguages;
  // }

  // return userLang as SupportedLanguages;
}

export function updateUserLang(lang: string) {
  localStorage.setItem(USER_LANG_KEY, lang.toLowerCase());
}

function getNavigatorLang(): string {
  const lang = navigator.language;
  const m = lang.match(/(^[a-z]{2})/);
  return m && m.length > 1 ? m[1] : DEFAULT_LANGUAGE;
}

const cache = createIntlCache();

const currentUserLocale = getUserLocalization();
export let IntlCore = createIntl(
  {
    locale: currentUserLocale,
    messages: LANG_RESOURCES[currentUserLocale as SupportedLanguages]
  },
  cache
);

export function syncIntlCore(lang: SupportedLanguages) {
  const newIntl = createIntl(
    {
      locale: lang,
      messages: LANG_RESOURCES[lang]
    },
    cache
  );
  IntlCore = newIntl;
  // updateUserLang(lang);
}

export const getTranslateString = (text: string | (() => string)) => {
  return typeof text === 'function' ? text() : text;
};

export const translate = (
  id: keyof MergeTranslateKeys,
  values?: Record<string, PrimitiveType>
): string => {
  return id != null ? IntlCore.formatMessage({ id }, values) : '';
};
